<template>
  <div id="home">
    <Options />
    <RasterMap />
    <Menu />
  </div><!-- /#home -->
</template>

<script>
import Options from './Options'
import RasterMap from './RasterMap'
import Menu from './Menu'

export default {
  components: {
    Options,
    RasterMap,
    Menu
  },
  created () {
    this.$store.dispatch('initPlugin', this.$route.params.farmId)
  }
}
</script>
